module.exports = __webpack_public_path__ + "img/newpartner2.ab29607a.png";